import {
    FETCH_ROLE,
    FETCH_ROLES,
} from '../actions/role';


export const initialState = {
    isFetching: true,
    data: null
};

export const roles = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ROLES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ROLES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const role = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ROLE}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ROLE}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/role.js